import { AlertService } from './../../core/services/alert.service';
import { ApiObjectData } from './../../core/models/api-object-data';
import { Student } from './../../core/models/student';
import { Component, OnInit, Pipe, ViewChild } from '@angular/core';
import { BaseComponent } from './../../components/base/base.component';
import { BaseService } from './../../core/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { StudentService } from '../../core/services/student.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register-student',
  templateUrl: './register-student.component.html',
  styleUrls: ['./register-student.component.scss']
})
export class RegisterStudentComponent extends BaseComponent implements OnInit {
  @ViewChild('studentForm', { static: false }) studentForm: NgForm;
  student = {} as Student;
  tokenValid = false;
  constructor(
    public baseService:BaseService,
    private studentService: StudentService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
  ) { super() }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    if (token && isTeacher) { this.tokenValid = false; }
    else { this.tokenValid = false; }
  }

  registerStudent() {
    this.student.isTeacher = false;
    this.baseService.blockStart();
    this.studentService.save(this.student).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.baseService.blockStop();
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('registeredSuccessfully'));
          this.student = {} as Student;
          this.studentForm.reset(this.student);
          this.router.navigate(['/login']);
        }
        else if (data.result.message.type === 'Error') {
          this.alertService.error(data.result.message.log)
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      }
    )
  }

  changeInput(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

}
